import {
  IconHomeActive,
  IconLogo,
  IconOpenBets,
  IconProfile,
  IconSettings,
  IconStatement,
} from "app/components/Icon/Icon";
import { ROUTES } from "app/helpers/routerPathHelper";
import { FormattedMessage } from "react-intl";
import NavBarReportsBadge from "../../components/NavBarReportsBadge/NavBarReportsBadge";
export const MenuItems = {
  logoItem: {
    path: ROUTES.root,
    title: "logo",
    type: "logo",
    icon: IconLogo,
    id: "logo",
    ariaLabel: "logo",
  },
  asianLogoItem: {
    path: ROUTES.asianEvents,
    title: "logo",
    type: "logo",
    icon: IconLogo,
    id: "logo",
    ariaLabel: "asia logo",
  },
  authenticatedMenuItems: [
    {
      path: "/events/",
      title: "Events",
      type: "link",
      icon: IconHomeActive,
      id: "home_section",
      ariaLabel: "home",
    },
    {
      path: ROUTES.reports,
      title: "Reports",
      type: "link",
      icon: NavBarReportsBadge,
      id: "report_section",
      ariaLabel: "reports",
    },
    {
      path: ROUTES.account,
      title: "Account",
      type: "link",
      icon: IconProfile,
      id: "account_section",
      ariaLabel: "account",
    },
  ],
  asianAuthenticatedMenuItems: [
    {
      path: ROUTES.asianOpenBets,
      title: <FormattedMessage tagName="span" id="navigation-open-bets" />,
      type: "link",
      icon: IconOpenBets,
      id: "open_bets_section",
      ariaLabel: "open bets",
    },
    {
      path: ROUTES.asianStatement,
      title: <FormattedMessage tagName="span" id="navigation-open-statement" />,
      type: "link",
      icon: IconStatement,
      id: "report_section",
      ariaLabel: "reports",
    },
    {
      path: ROUTES.asianSettings,
      title: <FormattedMessage tagName="span" id="navigation-open-settings" />,
      type: "link",
      icon: IconSettings,
      id: "account_section",
      ariaLabel: "accounts",
    },
  ],
};
